import { addProtocol, setWorkerUrl } from 'maplibre-gl'
import workerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url'
import { Protocol } from 'pmtiles'

const PmTileProtocol = new Protocol()
export const PM_TILES_PROTOCOL = 'pmtiles' as const
export const PM_TILES_PROTOCOL_REGISTERED_KEY =
  '__PmTilesProtocolRegistered__' as const

export function registerPmTilesProtocol() {
  setWorkerUrl(workerUrl)

  const globalWithProtocolFlag = globalThis as typeof globalThis & {
    [PM_TILES_PROTOCOL_REGISTERED_KEY]?: boolean
  }

  if (!globalWithProtocolFlag[PM_TILES_PROTOCOL_REGISTERED_KEY]) {
    addProtocol(PM_TILES_PROTOCOL, PmTileProtocol.tile)
    globalWithProtocolFlag[PM_TILES_PROTOCOL_REGISTERED_KEY] = true
  }
}
